import React from 'react'
import ContactScreen from '../Components/Contact/ContactScreen'
import ContactMap from '../Components/Contact/ContactMap'
import ContactBanner from '../Components/Contact/ContactBanner'

const ContactUs = () => {
    return (
        <>
            <ContactBanner />
            <ContactScreen />
            <ContactMap />
        </>
    )
}

export default ContactUs